export default {
  trigger: 'Convidar proprietário do restaurante',
  title: 'Convidar o proprietário do restaurante',
  description:
    'Crie uma conta para o proprietário do restaurante. Receberá um e-mail com uma palavra-passe temporária para iniciar sessão e concluir a configuração do restaurante.',
  fields: {
    first_name: 'Nome',
    last_name: 'Apelido',
    email: 'E-mail',
  },
  buttons: {
    invite: 'Enviar convite',
    cancel: 'Cancelar',
  },
  toasts: {
    invited: 'Foi enviado um convite a {{email}} para concluir a configuração.',
    failed: 'Não foi possível criar a conta do proprietário. Por favor, tente novamente.',
  },
};
